// extracted by mini-css-extract-plugin
export default {"toggle":"ElX5MfKVYywUX0Opnj0S","label":"ASCEJIYsAlEKDR3sPeqQ","switch":"LRx2Z9E72MeBmGpmbHnr","disabled":"be_am14W9EfFx6yr8Vc0"};